import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import HeaderComponent from '../../components/header/Header.component';
import FooterComponent from '../../components/portalComponents/Footer.component';
import { endpoints, POST } from '../../services/modulesServices/userManagement.api';
import { CIRCULAR_TABLE_COLUMNS } from '../modules/UserManagement/UserManagement.const';
import { useTranslation } from 'react-i18next';
import PopUps from '../../components/PopUps';
import { OwnershipTable } from '../modules/UserManagement/EnterpriseModule/OwnershipTable';
import { cross } from '../../utils/Logo';
import Loading from '../../components/portalComponents/Loading.component';
import GenericActionTable from '../../components/moduleCommonFormik/GenericActionTable';

export default function CircularPage(props: any) {
    const { t } = useTranslation();
    const [circularDetails, setCircularDetails] = useState<any>(null);
    const [modalDetails, setModalDetails] = useState({});
    const [isLoading, setIsLoading] = useState<boolean>(false);

    useEffect(() => {
        const fetchAllCirculars = async () => {
            try {
                setIsLoading(true);
                const res = await POST(endpoints.getCommonDocument + `?documentCategories=CIRCULARS`, { RequestInfo: {} });
                const resData = res?.data?.documentDetails.map((item: any) => ({
                    ...item,
                    description: item?.content,
                    documentName: {
                        docReferenceId: item.documentReferenceId,
                        documentName: item.documentName
                    },
                    publishDate: item?.createdDate
                }));
                setCircularDetails(resData);
                setIsLoading(false);
            } catch (e: any) {
                setIsLoading(false);
                let errMsg = e.response?.data?.errorMessage || e.response?.data?.Errors?.[0]?.message || t('SOMETHING_WENT_WRONG', 'Something went wrong');
                setModalDetails({ show: true, title: 'Error!', para: errMsg, img: cross, type: 'error', reUpload: 'OK' });
            }
        };
        fetchAllCirculars();
    }, []);

    return (
        <>
            {isLoading ? (
                <Loading />
            ) : (
                <>
                    <PopUps modalDetails={modalDetails} setModalDetails={setModalDetails} />
                    <HeaderComponent />
                    <div className='mx-5 p-5 font-inter'>
                        <div style={{ width: '764px', height: '14px' }}>
                            <p className='breadcrumbs'>
                                <Link className='text-decoration-none' to='/goa-idc/'>
                                    {t('HOME', 'Home')}
                                </Link>{' '}
                                / {t('CIRCULARS', 'Circulars')}
                            </p>
                        </div>
                        <div className='col-md-8' style={{ fontWeight: 500, fontSize: '48px', lineHeight: '76.8px', letterSpacing: -1 }}>
                            {t('CIRCULARS', 'Circulars')}
                        </div>
                        <OwnershipTable column={CIRCULAR_TABLE_COLUMNS} tableRowData={circularDetails} searchBarPlaceholder='SEARCH_CIRCULAR' itemsPerPage={5}></OwnershipTable>
                        {/* <GenericActionTable columns={CIRCULAR_TABLE_COLUMNS} rowData={circularDetails}  searchBarPlaceholder='SEARCH_CIRCULAR'></GenericActionTable> */}
                    </div>
                    <FooterComponent />
                </>
            )}
        </>
    );
}
